import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button.component';
import { NavigationLinkDirective } from './navigation-link/navigation-link.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ButtonComponent, NavigationLinkDirective],
  exports: [ButtonComponent, NavigationLinkDirective],
})
export class UiV3ButtonModule {}
